import OrderDTO from "@/dto/order/OrderDTO";
import OrderMergeSplitStatus from "@/enum/OrderMergeSplitStatus";
import { calcOrderProfit } from "@/utils/OrderUtils";
import Big from "big.js";
import React, { useMemo } from "react";

interface SellerReceiptsColumnProps {
    order: OrderDTO;
}

const SellerReceiptsColumn: React.FC<SellerReceiptsColumnProps> = function (props) {
    const { order } = props;

    const profit = useMemo(() => calcOrderProfit(order), [order]);

    // 利润= 订单实收金额-订单全部商品的成本价
    const profitEl = profit ? (
        <p>
            <span className="text-gray small">利润:{profit}元</span>
        </p>
    ) : null;

    if (order.payments && order.sellerReceipts && order.payments !== order.sellerReceipts) {
        return (
            <td>
                <span>{order.sellerReceipts}</span>
                {order.platformDiscounts ? (
                    <p className="text-gray small">平台优惠:{order.platformDiscounts}元</p>
                ) : null}
                {profitEl}
            </td>
        );
    }

    return (
        <td>
            <span>{order.sellerReceipts}</span>
            {profitEl}
        </td>
    );
};

export default React.memo(SellerReceiptsColumn);
